<template>
  <div class="bg-soft border rounded mt-2 p-3 font-mono break-all whitespace-pre-wrap">
    <vx-tooltip :text="tooltipText"
                :key="tooltipText"
                position="top"
                class="justify-end"
                :enabled="tooltipText.length > 0"
    >
      <span v-html="getTextWithSubstitutions"/>
    </vx-tooltip>
  </div>
</template>

<script>
import contentUtils from '@/utils/content.utils'
import clone from 'ramda/src/clone'

export default {
  name: 'JsonPreview',

  props: {
    data: {
      type: Object,
      default: null
    },
    formData: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      contextKey: null
    }
  },

  computed: {
    tooltipText() {
      if (this.contextKey) {
        return `<div style="font-size: 0.875rem; white-space: nowrap;">
          <b>Interpolation key:</b>
          </div>
          ${this.contextKey}
        `
      }
      return ''
    },

    getTextWithSubstitutions() {
      const data = clone(this.data)
      try {
        const parsed = JSON.parse(this.data.body)
        data.body = parsed
      } catch (err) {
        data.body = this.data.body
      }
      const subbedText = contentUtils.markSubstitutedText(JSON.stringify(data), this.formData.data.context)
      const substitutedSpanList = []
      const preprocessedText = this.preprocessText(subbedText, substitutedSpanList)

      try {
        // Parse the JSON to format it properly
        const parsed = JSON.parse(preprocessedText)
        const formatted = JSON.stringify(parsed, null, 2)
        return this.postprocessText(formatted, substitutedSpanList)
      } catch (error) {
        // If JSON parsing fails, return the original text
        return subbedText
      }
    }
  },

  methods: {
    setupContextTooltipListeners() {
      this.$nextTick(() => {
        const contextElements = this.$el.querySelectorAll('.context-substituted')
        contextElements.forEach(element => {
          element.addEventListener('mouseenter', this.handleContextMouseEnter)
          element.addEventListener('mouseleave', this.handleContextMouseLeave)
        })
      })
    },

    removeContextTooltipListeners() {
      const contextElements = this.$el.querySelectorAll('.context-substituted')
      contextElements.forEach(element => {
        element.removeEventListener('mouseenter', this.handleContextMouseEnter)
        element.removeEventListener('mouseleave', this.handleContextMouseLeave)
      })
    },

    handleContextMouseEnter(event) {
      const contextKey = event.target.getAttribute('data-context')
      if (contextKey) {
        this.contextKey = contextKey
      }
    },

    handleContextMouseLeave() {
      this.contextKey = null
    },

    preprocessText(text, substitutedSpanList) {
      let i = 0
      return text.replace(/<span[^>]*>[\s\S]*?<\/span>/g, (match) => {
        const id = `<${i++}>`
        substitutedSpanList.push(match)
        return id
      })
    },

    postprocessText(text, substitutedSpanList) {
      let i = 0
      return text.replace(/(<|&lt;)\d+(>|&gt;)/g, () => substitutedSpanList[i++])
    }
  },

  mounted() {
    this.setupContextTooltipListeners()
  },

  updated() {
    this.removeContextTooltipListeners()
    this.setupContextTooltipListeners()
  },

  beforeDestroy() {
    this.removeContextTooltipListeners()
  }
}
</script>

<style lang="scss">
.context-substituted {
  text-decoration: underline;
  text-decoration-style: dotted;
}
</style>
